import React from 'react'
import image from '../../static/images/trusted-device.png'
import styled from '@emotion/styled'
import { Button } from '../Common/V2'
import { gapY } from '../Utils/gap'
import { font, colors } from '../Theme/Common'

type Props = {
  /*
   * Handler that will be invoked if the user wants their device to be trusted
   */
  onTrustDevice?: VoidFunction
  /*
   * Handler that will be invoked if the user wants to skip trusting the device
   */
  onSkip?: VoidFunction
}

export const TrustedDevicePrompt = ({ onTrustDevice, onSkip }: Props) => {
  return (
    <Stack>
      <div>
        <HeaderImageStyled src={image} alt='Mobile phone' />
      </div>
      <Title>Is this your trusted device?</Title>
      <Subtitle>
        Add it as a trusted device to your TABtouch account for quicker, secure access.
      </Subtitle>
      <Button aria-label='Trust this device' isFullWidth onClick={onTrustDevice}>
        Trust this device
      </Button>
      <Button aria-label='Skip' isFullWidth color='secondary_color' onClick={onSkip}>
        Skip for now
      </Button>
    </Stack>
  )
}

export const HeaderImageStyled = styled.img({
  width: '100%',
  height: 'auto',
})

const Stack = styled.div(
  {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    alignItems: 'center',
    fontFamily: font.family.primary,
  },
  gapY('0.8rem')
)

const Title = styled.h1({
  fontWeight: font.weight.semibold,
  ...font.size.xl2,
  margin: 0,
})

const Subtitle = styled.div({
  fontWeight: font.weight.regular,
  ...font.size.md,
  color: colors.neutral[700],
  textAlign: 'center',
})
